"use strict";

function helper(Handlebars) {
  /**
   * Return ordinal of number. Ignore NaN.
   *
   * {{ordinal 1}} returns "1st"
   * {{ordinal 2}} returns "2nd"
   * {{ordinal 3}} returns "3rd"
   * {{ordinal 4}} returns "4th"
   * {{ordinal 11}} returns "11th"
   *
   * @return {String} ordinal of the number
   */
  /* eslint no-bitwise: "error" */
  function ordinal(value) {
    // eslint-disable-next-line no-bitwise
    var i = ~~Number(value); // convert to integer, '~~Number(x)' truncates fractional portion of x
    var isInteger = String(i) === String(value);
    if (!isInteger) {
      return value || '';
    }
    var lastDigit = i % 10;
    var suffix;

    // eslint-disable-next-line no-bitwise
    if (~~(i % 100 / 10) === 1) {
      suffix = 'th';
    } else if (lastDigit === 1) {
      suffix = 'st';
    } else if (lastDigit === 2) {
      suffix = 'nd';
    } else if (lastDigit === 3) {
      suffix = 'rd';
    } else {
      suffix = 'th';
    }
    return i + suffix;
  }
  Handlebars.registerHelper('ordinal', ordinal);
  return ordinal;
}
module.exports = helper;
